import React from 'react';
import { ReportHeader } from './components/ReportHeader';
import { InventoryItemsGrid } from '../../components/InventoryItemsGrid/InventoryItemsGrid';
import { useInventoryReport } from './useInventoryReport';
import './index.css';

const InventoryReport = () =>
{
  const { inventoryId, posId, inventory, items, total, issues, resolved, remaining, loading, error } = useInventoryReport();

  if (loading)
  {
    return <div className="inv-report-loading">Loading inventory report...</div>;
  }

  if (error)
  {
    return <div className="inv-report-error">Error loading inventory report.</div>;
  }

  return (
    <div className="inv-report-page">
      <ReportHeader
        inventoryId={inventoryId}
        inventoryName={inventory?.name}
        posId={posId}
        total={total}
        issues={issues}
        resolved={resolved}
        remaining={remaining}
      />
      <InventoryItemsGrid
        items={items}
        loading={false}
        error={null}
        readOnly
      />
    </div>
  );
};

export default InventoryReport;
